module.exports = __webpack_public_path__ + "img/list-none.9ce7760d.png";